var map = {
	"./MyCoursesStore.js": [
		37005
	],
	"./StudipStore.js": [
		6072,
		6072
	],
	"./courseware/courseware-activities.module.js": [
		5999,
		5999
	],
	"./courseware/courseware-admin.module.js": [
		10871,
		871
	],
	"./courseware/courseware-links.module.js": [
		22608,
		2608
	],
	"./courseware/courseware-public.module.js": [
		22850,
		2850
	],
	"./courseware/courseware-shelf.module.js": [
		553,
		553
	],
	"./courseware/courseware-tasks.module.js": [
		1490,
		1490
	],
	"./courseware/courseware.module.js": [
		60408,
		9669,
		408
	],
	"./courseware/public-structure.module.js": [
		92643,
		2643
	],
	"./courseware/structure.module.js": [
		23887,
		3887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53651;
module.exports = webpackAsyncContext;